export { default } from './CGMScatterChart';
